import http from '@/utils/services/http'

export default {
  online () {
    return http.get('/api/chat/online')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  loadMessages (user, group, onlyNotReads) {
    return http.get('/api/chat/messages?user=' + user + '&group=' + group + '&onlyNotReads=' + onlyNotReads)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  loadNotReadedMessages () {
    return http.get('/api/chat/naoLidas')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  sendMessage (user, group, message) {
    return http.post('/api/chat/sendMessage?destinatario=' + user + '&group=' + group, message)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getCountNotReadMessages (id) {
    return http.get('/api/chat/countMessages/' + id)
      .then(response => Promise.resolve(response))
  },
  setVisualizado (remetenteid, destinatarioid) {
    return http.patch('/api/chat/setVisualizado/' + remetenteid + '/' + destinatarioid)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/chat/services/chat.js